import React, {useRef, useState} from "react";
import { Box, Button, Column, Columns, Control, Field, Input, Pagination, Tabs } from "@allxsmith/bestax-bulma";
import {
  getContactsData,
  getDataFresh,
  getDepartmentsData,
  getFittersData,
  getJobsData, getJobStatusCountData
} from "../../state/selectors";
import {useDispatch, useSelector, useStore} from "react-redux";
import Spinner from "react-spinner-material";
import { useJobsData } from "../../hooks/useJobsData";
import {
  createSetJobsDataAction, createSetJobsFieldDataActions,
} from "../../actions/dataActions";
import JobRow from "./JobRow";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import {useReactToPrint} from "react-to-print";
import PrintListWash from "./PrintListWash";
import {useWorkshopsData} from "../../hooks/useWorkshopsData";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useFittersData} from "../../hooks/useFittersData";
import PrintJobList from "./PrintJobList";
import SearchBar from "../Utils/SearchBar";
import {useJobStatusCountData} from "../../hooks/useJobStatusCountData"
import ExternalVehicleView from "./External Vehicles/View";
import FigureSummary from "../Figures/FigureSummary";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import PrintMultiPartList from "./PrintMultiPartList";
import useSelect from "../../hooks/useSelect";
import InfoModal from "./InfoModal";
import Nav from "../Nav/Nav";
import PaginationWrapper from "../Utils/PaginationWrapper";
import LoadingSpinner from "../Utils/Spinner";

function Job(props) {
  const [page, setPage] = useState(1);
  const [date, setDate] = useState();
  const [activeView, setView] = useState("started");
  const [activeTab, setTab] = useState("all");
  const [searchText, setSearchText] = useState();
  const [currentSearch, setCurrentSearch] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState(-1);
  const [keyFilter, setKeyFilter] = useState();
  const [searchFresh, setSearchFresh] = useState(1);
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const dispatch = useDispatch();
  let dataFresh = useSelector(getDataFresh);
  const componentRef = useRef();
  const printJobListRef = useRef();
  const printMultiPartRef = useRef();

  const handlePrint = useReactToPrint({contentRef: componentRef});
  const handleJobListPrint  = useReactToPrint({contentRef: printJobListRef});
  const handleMultiPartPrint = useReactToPrint({contentRef:  printMultiPartRef});


  let params = { page, view: activeView, date: date};
  const [filters, setFilters] = useState({});

  const [partsView, partsViewInput] = useSelect({
    label: "Parts Arrived",
    options: [
      { name: "All", value: "all"},
      { name: "Arrived", value: "arrived"},
      { name: "Not Arrived", value: "not_arrived"}
    ],
    initialValue: "all",
    callback: () => setPage(1)
  });


  const headings = [
    {
        label: "Job no.",
    },
    {
        label: "Registration",
        field: "vehicle",
        labelField: "vehicle__registration"
    },
    {
        label: "Description"
    },
    {
        label: "Comments"
    },
    {
        label: "Customer",
        field: "customer",
        labelField: "customer__display_name"
    },
    {
        label: "Customer2",
        field: "customer2",
        labelField: "customer2__display_name"
    },
    {
      label: "Fitter",
      field: "fitter",
      labelField: "fitter__name",
      plusBlanks: true,
      objField: true
    },
    {
        label: "Estimated Hours"
    },
    {
      label: "Work Hours"
    },
    {
        label: "Make"
    },
    {
        label: "Model"
    },
    {
        label: "Job Status",
        field: "status",
        labelField: "status"
    },
    {
      label: "Key Number"
    },
    {
      label: "Vehicle Arrived"
    },
    {
      label: "All Parts Arrived"
    },
    {
      label: "Wash Needed"
    },
    {
      label: "Job Creation Date"
    },
    {
        label: "Workshop Date",
        field: "workshop_date",
        labelField: "workshop_date",
        date : true
    },
    {
        label: "Book in Date",
        field: "book_in_date",
        labelField: "book_in_date",
        date: true,
        noBlank: true
    },
    {
        label: "Workshop",
        field: "workshop",
        labelField: "workshop__display_name"
    }
  ];

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }

  if (activeTab) {
    params.ws = activeTab;
  }

  if (currentSearch) {
    params.search = currentSearch;
  }
  if (searchFresh){
    params.searchFresh = searchFresh;
  }
  if (selectedDepartment){
    params.department = selectedDepartment;
  }
  if (keyFilter){
    params.key = keyFilter;
  }
  if(partsView){
    params.part_view = partsView;
  }
  let countParams = {};
  if(activeTab){
    countParams.ws = activeTab;
  }
  const complete = useJobsData(params, dataFresh);
  const departmentsComplete = useDepartmentsData({}, dataFresh);
  const fittersComplete = useFittersData({page_size:1000}, dataFresh);
  const departments = useSelector(getDepartmentsData);
  const fitters = useSelector(getFittersData);
  const data = useSelector(getJobsData);
  const completeTabs = useWorkshopsData({}, dataFresh);
  const tabs = useSelector(getContactsData);

  //const defectCountComplete = useDefectCountData({});
  //const enquiryCountComplete = usePartEnquiryCountData({});
  const jobStatusCountComplete = useJobStatusCountData(countParams, dataFresh);

  //let defectCount = useSelector(getDefectCountData);
  //let enquiryCount = useSelector(getEnquiryCountData);
  let jobStatusCount = useSelector(getJobStatusCountData);

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh+1);
  };

  const setNewView = (view) => {
    setPage(1)
    setView(view)
    setDate()
  };

  const setNewTab = (tab) => {
    setPage(1)
    setTab(tab)
  };

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };
  const onDepartmentChange = (e) => {
    setSelectedDepartment(e.target.value);
  }
  const onJobUpdate = (index, newJob) => {
    let newResults = [...data.results];
    let newState = { ...data, results: newResults };
    newState.results[index] = newJob;
    dispatch(createSetJobsDataAction(newState));
  };

  const onKeyFilterChange = (e) =>{
    setKeyFilter(e.target.value);
  }
  if (!complete || !completeTabs || !departmentsComplete || !fittersComplete ){//|| !defectCountComplete || !enquiryCountComplete) {
    return (
        <div>
          <Nav/>
          <LoadingSpinner/>
        </div>
    );
  }

  document.title = "Jobs";

  // TODO(bestax-migrate): Tabs.Tab became a plain element; the Bulma helper prop(s) `textColor` were dropped — restyle with classes
  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      {/*<Figures department={selectedDepartment}/>*/}
      <ExternalVehicleView {...props} dataFresh={dataFresh}/>
      <Box>
        <h1 className="title">Jobs</h1>
        <Columns isMultiline>
          <Column>
            <label className="label">Search for a Job</label>
            <SearchBar
              handleSearch={handleSearch}
              setSearchText={setSearchText}
              searchText={searchText}
              clear={clear}
            />
          </Column>
          <Column>
           <DepartmentSelector
                name={"department"}
                label={"Department"}
                onChange={onDepartmentChange}
                value={selectedDepartment}
                options={departments}
                blank={true}
                editable={true}
           />
          </Column>
          {partsViewInput}
          {/*<Columns.Column>*/}
          {/*  <KeyFilterDropDown*/}
          {/*    selectedFilter={keyFilter}*/}
          {/*    onChange={onKeyFilterChange}*/}
          {/*  />*/}
          {/*</Columns.Column>*/}
          <Column>
            <Button
              color={"info"}
              onClick={()=>setInfoModalOpen(true)}
            >
              Info
            </Button>
          </Column>
          <Column>
            <Field>
              <Control>
                <Button
                  onClick={() => window.open("/editjob/", "_self")}
                  color="success"
                  className="is-pulled-right"
                >
                  New Job +
                </Button>
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <Button
                  color={"success"}
                  className={"is-pulled-right"}
                  onClick={() => window.open("/partenquiry", "_self")}
                >
                  New Part Enquiry +
                </Button>
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <Control>
                <Button
                  onClick={() => window.open("/defect", "_self")}
                  color="success"
                  className="is-pulled-right"
                >
                  New Defect +
                </Button>
              </Control>
            </Field>
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <FigureSummary selectedDepartment={selectedDepartment}/>
          </Column>
        </Columns>
        <Tabs fullwidth align="centered" boxed>
          <Tabs.List>
            <Tabs.Item active={activeTab === "all"}><a onClick={() => setNewTab("all")}>ALL
                        </a></Tabs.Item>
            <Tabs.Item active={activeTab === "quotes"}><a onClick={() => setNewTab("quotes")}>QUOTE JOBS
                        </a></Tabs.Item>
            <Tabs.Item active={activeTab === "external"}><a onClick={() => setNewTab("external")}>EXTERNAL
                        </a></Tabs.Item>
            {/*{tabs.results.map((tab) => (*/}
            {/*    <Tabs.Item active={activeTab === tab.display_name}><a onClick={() => setNewTab(tab.display_name)}>*/}
            {/*        {tab.display_name}*/}
            {/*      </a></Tabs.Item>*/}
            {/*))}*/}
          </Tabs.List>
        </Tabs>
        <Tabs align="centered" toggle>
          <Tabs.List>
            <Tabs.Item
              active={activeView === "part_enquiry"}
              className={jobStatusCountComplete ? (jobStatusCount && jobStatusCount['enquiry'] > 0) ? "table-highlight-red": "" : ""}
            >
              <a
                  onClick={() => setNewView("part_enquiry")}
                  className={jobStatusCountComplete ? (jobStatusCount && jobStatusCount['enquiry'] > 0) ? "white": "" : ""}
              >
                Part Enquiries {(jobStatusCountComplete && jobStatusCount) ? "("+jobStatusCount['enquiry']+")" : ""}
              </a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "user_defect"}>
              <a
                  onClick={() => setNewView("user_defect")}
              >
                My Defects
              </a>
            </Tabs.Item>
            <Tabs.Item
              active={activeView === "defect"}
              className={jobStatusCountComplete ? (jobStatusCount && jobStatusCount['defect'] > 0) ? "table-highlight-red": "" : ""}
            >
              <a
                  onClick={() => setNewView("defect")}
                  className={jobStatusCountComplete ? (jobStatusCount && jobStatusCount['defect'] > 0) ? "white": "" : ""}
              >
                Defects {(jobStatusCountComplete && jobStatusCount) ? "("+jobStatusCount['defect']+")" : ""}
              </a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "awaiting_approval"}>
              <a
                  onClick={() => setNewView("awaiting_approval")}
              >
                Awaiting Approval
              </a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "yesterday"}>
              <a onClick={() => setNewView("yesterday")}>Yesterday {(jobStatusCountComplete && jobStatusCount) ? "("+jobStatusCount.yesterday+")" : ""}</a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "today"}>
              <a onClick={() => setNewView("today")}>Today {(jobStatusCountComplete && jobStatusCount) ? "("+jobStatusCount.today+")" : ""}</a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "started"}>
              <a onClick={() => setNewView("started")}>Started {(jobStatusCountComplete && jobStatusCount) ? "("+jobStatusCount.started+")" : ""}</a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "all_not_approved"}>
              <a onClick={() => setNewView("all_not_approved")}>All Not Approved</a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "upcoming"}>
              <a onClick={() => setNewView("upcoming")}>Upcoming {(jobStatusCountComplete && jobStatusCount) ? "("+jobStatusCount.upcoming+")" : ""}</a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "upcoming_not_booked"}>
              <a onClick={() => setNewView("upcoming_not_booked")}>Upcoming Not Booked {(jobStatusCountComplete && jobStatusCount) ? "("+jobStatusCount.upcoming_not_booked+")" : ""}</a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "returned"}>
              <a onClick={() => setNewView("returned")}>Returned From Workshop {(jobStatusCountComplete && jobStatusCount) ? "("+jobStatusCount.returned+")" : ""}</a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "wash_needed"}>
              <a onClick={() => setNewView("wash_needed")}>Wash Needed {(jobStatusCountComplete && jobStatusCount) ? "("+jobStatusCount.wash+")" : ""}</a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "ready_for_collection"}>
              <a onClick={() => setNewView("ready_for_collection")}>Ready For Collection {(jobStatusCountComplete && jobStatusCount) ? "("+jobStatusCount.collection+")" : ""}</a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "approved"}>
              <a onClick={() => setNewView("approved")}>Approved</a>
            </Tabs.Item>
            <Tabs.Item active={activeView === "all"}>
              <a onClick={() => setNewView("all")}>All</a>
            </Tabs.Item>
          </Tabs.List>
        </Tabs>
        {(activeView === "wash_needed") &&
            <Column float={"right"}>
              <label className="label">Wash List Date</label>
              <Field className="contact-section has-addons">
                <Control>
                  <Input
                    type="date"
                    name="day"
                    value={date}
                    onChange={e => (setDate(e.target.value))}
                  />
                </Control>
              </Field>
            </Column>
        }
        <table className="table is-hoverable is-fullwidth is-striped">
          <thead>
            <tr className="small-row-black">
              {headings.map(heading => {
                if (!heading.field) {
                  return <th key={heading.label}>{heading.label}</th>;
                }
                if (heading.blank) {
                  return (
                    <FilterBlankHeading
                      key={heading.label}
                      heading={heading}
                      setFilters={f => {
                        setPage(1);
                        setFilters(f);
                      }}
                      filters={filters}
                    />
                  );
                }
                return (
                  <FilterHeading
                    key={heading.label}
                    heading={heading}
                    setFilters={f => {
                      setPage(1);
                      setFilters(f);
                    }}
                    filters={filters}
                    options={(data && data.filter_list) ? data.filter_list[heading.field]: []}
                  />
                );
              })}
              {(activeView === 'finished' || activeView === 'all') &&
                <th>Approver</th>
              }
              {(activeView === 'wash_needed') &&
                <th>Wash Completed</th>
              }
              {activeView === "wash_needed" &&
                <td onClick={e => e.stopPropagation()}>
                      <Button color="warning" onClick={handlePrint}>
                        Print Wash List
                      </Button>
                </td>
              }
            </tr>
          </thead>
          <tbody>
            {data && data.results.map((value, index) => (
              <JobRow
                key={index}
                job={value}
                onJobUpdate={onJobUpdate}
                index={index}
                endpoint={props.endpoint}
                showApprover={activeView === 'finished' || activeView === 'all'}
                fitters={fitters}
                showWash={activeView === "wash_needed"}
                showStatusChange={activeView === "ready_for_collection"}
              />
            ))}
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              {(activeView === 'finished' || activeView === 'all') &&
                  <td></td>
              }
              <td onClick={e => e.stopPropagation()}>
                        <Button
                            color="warning"
                            disabled={activeView==="defect" || activeView==="user_defect" || activeView==="part_enquiry"}
                            onClick={handleJobListPrint}
                        >
                          Print Job List
                        </Button>
              </td>
              <td onClick={e => e.stopPropagation()}>
                    <Button
                        color="warning"
                        disabled={activeView==="defect" || activeView==="user_defect" || activeView==="part_enquiry"}
                        onClick={handleMultiPartPrint}
                    >
                      Print Part List
                    </Button>
              </td>
            </tr>
          </tbody>
        </table>
        <div style={{display: "none"}}>
          <div>
            {activeView === 'wash_needed' &&
                <div ref={componentRef}>
                  <PrintListWash data={data} testId="PrintWashList"/>
                </div>
            }
            <div ref={printJobListRef}>
              <PrintJobList jobs={data} testId={"PrintJobsList"}/>
            </div>
            {complete &&
                <div ref={printMultiPartRef}>
                  <PrintMultiPartList jobs={data} testId={"PrintMultiPart"}/>
                </div>
            }
          </div>
        </div>
        <PaginationWrapper
            setPage={setPage}
            page={page}
            dataCount={data ? Math.ceil(data.count / 25) : 0}
        ></PaginationWrapper>
      </Box>
      <InfoModal
        show={infoModalOpen}
        setShow={setInfoModalOpen}
      />
    </div>
  );
}

export default Job;
